import React, { useEffect } from "react";
import { BooleanRadioFieldValue } from "../../types/fieldTypes";

export interface BooleanRadioFieldProps {
  value?: BooleanRadioFieldValue;
}

export const useBooleanRadioField = (props: BooleanRadioFieldProps) => {
  const [localValue, setLocalValue] = React.useState<BooleanRadioFieldValue>(
    props.value
  );

  useEffect(() => {
    setLocalValue(props.value);
  }, [props.value]);

  return { localValue, setLocalValue };
}; 